<script>
export default {
  name: "DidoApidocExamplesTools",
};
</script>

<script setup>
import DidoCodeHightlighting from "../codeHighlighting/Base.vue";

const codeRequestCurl = 'curl "$BASE_URL_API/datasets?page=1&pageSize=10"';
const codeResponseCurl = `{
  "data": [{...}, ..., {...}],
  "total": 25
  "firstPage": "$BASE_URL_API/datasets?page=1&pageSize=10&orderBy=-last_modified",
  "previousPage": "",
  "nextPage": "$BASE_URL_API/datasets?page=2&pageSize=10&orderBy=-last_modified",
  "lastPage": "$BASE_URL_API/datasets?page=3&pageSize=10&orderBy=-last_modified",
  "page": 1,
  "pageSize": "10"
}`;
const codeRequestJq =
  'curl "$BASE_URL_API/datasets?page=1&pageSize=10" | jq ".data[].title"';
const codeResponseJq = `"Données locales de consommation d'électricité et de gaz naturel et de chaleur et de froid - adresse (à partir de 2018)"
"Données locales de consommation d'électricité et de gaz naturel - région (à partir de 2018)"
"Conjoncture mensuelle de l'énergie"
"Données nationales sur la commercialisation des logements neufs"
"Données régionales sur la commercialisation des logements neufs"
"Données selon le zonage ABC sur la commercialisation des logements neufs"
"Indicateurs territoriaux de développement durable (ITDD)"
"Données départementales sur la commercialisation des logements neufs"
"Données détaillées du prix des terrains et du bâti"
"Qualité de l'air extérieur : indicateurs nationaux"`;
</script>

<template>
  <div class="q-mt-md line-height-15">
    Les exemples utilisent l'outil
    <a href="https://curl.se/" title="Lien vers l'outil curl" target="_blank"
      >curl</a
    >
    (client http) et
    <a
      href="https://stedolan.github.io/jq/"
      title="Lien vers l'outil jq"
      target="_blank"
      >jq</a
    >
    (parseur json) pour pouvoir interagir avec l'api DiDo. <br /><br />
    Vous pouvez vérifier que curl fonctionne :
    <DidoCodeHightlighting :code="codeRequestCurl" language="shell" />
    qui doit renvoyer ce type de réponse :
    <DidoCodeHightlighting :code="codeResponseCurl" language="javascript" />

    Il y a beaucoup d'informations.
    <br />
    Nous pourrons donc utiliser jq pour récupérer uniquement les informations
    qui nous intéressent.
    <br /><br />
    Maintenant nous vérifions que jq fonctionne :
    <DidoCodeHightlighting :code="codeRequestJq" language="shell" />
    qui doit retourner une réponse de ce type :
    <DidoCodeHightlighting :code="codeResponseJq" language="shell" />
  </div>
</template>
